import { gql } from 'apollo-boost'

export const PUBLIC_UPDATE_UPLOAD_STATUS = gql`
  mutation PublicUpdateUploadStatus($licenseKey: String!, $uploadId: UUID!, $status: String!) {
    publicUpdateUploadStatus(licenseKey: $licenseKey, uploadId: $uploadId, status: $status) {
      success
    }
  }
`
